import React from "react";
import contextProvider from "../../contextProvider";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../_L0_components/Widgets/_LoadingKit";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import ReactOForm from "../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../_L1_components/Elements/ReactOFormInput";
import Section from "../../_L1_components/Layout/Section";
import MeasureAggregateList from "../Elements/MeasureAggregateList";
import { Badge, ButtonGroup, Input, FormFeedback, FormText } from "reactstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

class AggregateMeasuresFlat extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: {},
      msgCopy: "Copy link",
      filteredDataTags: [],
      // connectionCriteria: null,
      showInputTime: false,
      range: undefined,
      isCustom: false,
      invalidCustomRange: false,
      invalidCustomRangeMsg: "",
      viewRangeData: null,
    };
    super(props, initState);

    this.dateRangePicker = React.createRef();
    this.apiStore = null;
    this.orderedTags = [];
    this.mlist = [];
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    if (!this.props.location?.state?.mlist) {
      this.getAppContext().redirectTo("/dashboard");
      return;
    }

    this.getAppContext()
      .getLocalStorageService()
      .set("goBackTags", JSON.stringify(this.props.location?.state));

    if (this.props.match.params.probeuid) {
      this.getAppContext()
        .getLocalStorageService()
        .set("goBackProbeid", this.props.match.params.probeuid);
    }

    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this._view_form.init();
    this._view_form.submit();
    // this.getProbeConf();
  }

  componentDidUpdate(prev_props) {
    if (
      this.props.match.params.status != prev_props.match.params.status &&
      this._view_form
    ) {
      if (this._CURR_status_view !== undefined) {
        this._view_form.submit();
      }
    }
    if (
      (prev_props.match.params.probeuid !== undefined &&
        prev_props.match.params.probeuid != this.props.match.params.probeuid) ||
      (prev_props.match.params.measureid !== undefined &&
        prev_props.match.params.measureid != this.props.match.params.measureid)
    ) {
      this._view_form.submit();
    }
  }

  loadMeasuresList(data, cb, opts) {
    this.getAppContext()
      .getLocalStorageService()
      .set("measure_graph_view", data);

    this.setState(
      {
        loading: true,
        conf_set: undefined,
        viewrange: data,
      },
      () => {
        const probeId = Object.keys(this.props.location.state.mlist)[0];
        // console.log("probeId", this.props.location.state.mlist);
        this.apiStore.fire("get_aggregate_flat", {
          data: {
            // measureid: this.props.match.params.measureid || "overal",
            viewrange: data,
            mlist: this.props.location.state.mlist || {},
            tag: this.props.location?.state?.selectedTags || [],
          },
          ___onSuccess: (status, response_data) => {
            let freqData = undefined;
            let filteredData = undefined;
            if (response_data.measures_list) {
              filteredData = response_data.measures_list[0];
              if (filteredData && filteredData.dataPerBssid) {
                freqData = filteredData.dataPerBssid
                  .filter((elem) => {
                    return elem.last_freq;
                  })
                  .reduce((sums, entry) => {
                    let { curr_f } = entry.last_freq;
                    if (curr_f < 5000) {
                      sums["2.4"] = (sums["2.4"] || 0) + 1;
                    } else if (curr_f < 5925) {
                      sums["5"] = (sums["5"] || 0) + 1;
                    } else {
                      sums["6"] = (sums["6"] || 0) + 1;
                    }
                    return sums;
                  }, {});
              }
            }

            if (this.mounted) {
              this.getProbeConf(probeId);
              this.setState({
                data: response_data,
                filteredData: filteredData ? filteredData : undefined,
                freqData: freqData,
                loading: false,
                connectionCriteria:
                  response_data.measures_list[0].connection_criteria || null,
                // countTag,
                ...(!this._IS_AUTO_RELOADING
                  ? { showInputTime: false, range: undefined }
                  : {}),
              });
            }
          },
          ___onEnd: () => {
            if (this._IS_AUTO_RELOADING) {
              this._IS_AUTO_RELOADING = false;
            }
            if (this._AUTO_RELOAD_TIMEOUT) {
              clearTimeout(this._AUTO_RELOAD_TIMEOUT);
            }
            if (data.is_preset == "yes" && !data.offset) {
              this._AUTO_RELOAD_TIMEOUT = setTimeout(() => {
                this._IS_AUTO_RELOADING = true;
                this._view_form.submit(null, { no_error_handle: true });
              }, 60000);
            }
          },
        });
      },
    );
  }

  getProbeConf(probeId) {
    this.apiStore.fire("probe_cst_sync_status", {
      data: {
        probeuid: probeId,
      },
      ___onSuccess: (status, data) => {
        if (this.mounted) {
          this.setState((prev_state) => {
            prev_state.conf_set = data;
            return prev_state;
          });
        }
      },
    });
  }

  checkFutureTime(etime) {
    const now = this.getAppContext().momentjs().unix();
    const normalizeToMinute = (epoch) => Math.floor(epoch / 60);
    return normalizeToMinute(etime) >= normalizeToMinute(now);
  }

  parseTime() {
    if (
      this._view_form &&
      this._view_form.isInitialized() &&
      this.state.viewRangeData
    ) {
      const is_preset = this._view_form.getEntry("is_preset");
      let from_ts = this.state.viewRangeData.stime;
      let to_ts = this.state.viewRangeData.etime;

      let _stime = from_ts
        ? this.getAppContext().momentjs(from_ts, "X").format("L LT")
        : "";

      let startDate = from_ts
        ? this.getAppContext().momentjs(from_ts, "X").format("L")
        : "";

      let _etime = to_ts
        ? this.getAppContext().momentjs(to_ts, "X").format("L LT")
        : "";

      let endDate = to_ts
        ? this.getAppContext().momentjs(to_ts, "X").format("L")
        : "";

      if (
        startDate == endDate &&
        !this.state.showInputTime &&
        is_preset == "yes"
      ) {
        let _text = to_ts
          ? _stime +
            " - " +
            this.getAppContext().momentjs(to_ts, "X").format("LT")
          : "";
        return _text;
      } else {
        let _text = _stime + " - " + _etime;
        return _text;
      }
    } else {
      return null;
    }
  }

  handleCustomRange() {
    return this.state.range !== undefined ? this.state.range : this.parseTime();
  }

  submitCustomRange() {
    let start = this.state.range.split("-")[0];
    let end = this.state.range.split("-")[1];

    if (
      this.getAppContext().momentjs(start, "L LT").isValid() &&
      this.getAppContext().momentjs(end, "L LT").isValid()
    ) {
      let start_customTime = this.getAppContext()
        .momentjs(start, "L LT")
        .unix();
      let end_customTime = this.getAppContext().momentjs(end, "L LT").unix();

      try {
        if (
          start_customTime &&
          end_customTime &&
          end_customTime > start_customTime
        ) {
          this._view_form.handleFormChange("is_preset", "no");
          this._view_form.handleFormChange("view_preset", "no");
          this._view_form.handleFormChange("offset", false);
          this._view_form.handleFormChange("stime", start_customTime);
          this._view_form.handleFormChange("etime", end_customTime);
          this._view_form.handleFormChange("snapStime", "");
          this._view_form.handleFormChange("snapEtime", "");
          this._view_form.submit();
          this.setState({ showInputTime: false, range: undefined });
        } else {
          throw new Error("Data interval not valid");
        }
      } catch (err) {
        console.error(err.message);
        this.setState({
          invalidCustomRange: true,
          invalidCustomRangeMsg: "Data interval not valid",
        });
      }
    } else {
      this.setState({
        invalidCustomRange: true,
        invalidCustomRangeMsg:
          "Sample date format: " +
          this.getAppContext().momentjs().format("L LT"),
      });
    }
  }

  onComponentWillUnmount() {
    this.mounted = false;
    if (this._AUTO_RELOAD_TIMEOUT) {
      clearTimeout(this._AUTO_RELOAD_TIMEOUT);
    }
  }

  onRender() {
    if (!this.props.location?.state?.mlist) {
      return null;
    }
    if (
      this.props.match.params.status != this._CURR_status_view &&
      this._view_form
    ) {
      if (this._CURR_status_view !== undefined) {
        this._view_form.submit();
      }
      this._CURR_status_view = this.props.match.params.status;
    }
    if (
      (this._CURR_probeuid !== undefined &&
        this._CURR_probeuid != this.props.match.params.probeuid) ||
      (this._CURR_measureid !== undefined &&
        this._CURR_measureid != this.props.match.params.measureid)
    ) {
      this._view_form.submit();
    }
    this._CURR_probeuid = this.props.match.params.probeuid;
    this._CURR_measureid = this.props.match.params.measureid;
    const selectedTags = this.props.location?.state?.selectedTags || [];
    return (
      <Section designType="wide">
        <Section
          designType="wide"
          className="mb-4 border-bottom border-3 border-gray300"
        >
          <div className="px-4">
            <div className="d-flex pt-4">
              <div className="flex-grow-1">
                <div className="d-flex align-items-center">
                  <a
                    className="text-dark text-decoration-none"
                    href={`${this.getAppContext().conf.BASENAME}/dashboard?tab=smart`}
                  >
                    <h2>Aggregate charts for tagged measures</h2>
                  </a>
                  {/* {this.state.data.measures_list &&
                    this.state.data.measures_list.length > 0 && (
                      <>
                        <div style={{ marginTop: "0.65em" }} className="ml-2">
                          {selectedTags
                            .sort((a, b) => {
                              const countDiff = b[1] - a[1];
                              return countDiff !== 0
                                ? countDiff
                                : a[0].localeCompare(b[0]);
                            })
                            .map((tag, id) => (
                              <Badge
                                key={"tag__" + id}
                                style={{
                                  fontSize: "16px",
                                  // cursor: "pointer",
                                }}
                                pill
                                className={`border mr-2 mb-1 bg-light text-primary border-primary`}
                              >
                                {tag}
                              </Badge>
                            ))}
                        </div>
                      </>
                    )} */}
                </div>
                <small className="text-left d-flex align-items-center mt-2">
                  <Section
                    className={
                      this.getAppContext().media.isMobile ||
                      this.getAppContext().media.isTablet
                        ? "flex-grow-1"
                        : ""
                    }
                    designType="wide"
                    layoutManager="grid"
                    elementsPerRow={
                      this.getAppContext().media.isMobile ||
                      this.getAppContext().media.isTablet
                        ? 1
                        : 5
                    }
                    gridSpacing={1}
                    gridSpacingColor={this.getAppContext().colors.gray300}
                  >
                    <div className={"flex-shrink-1 py-1 pr-2"}>
                      <strong className="text-muted">NETWORK:</strong>
                      <strong className="pl-2">
                        <span className="text-nowrap">
                          {this.state.data?.measures_list &&
                            this.state.data?.measures_list.length > 0 &&
                            this.state.data?.measures_list[0].essid}
                        </span>
                      </strong>
                    </div>
                    <div
                      className={
                        "flex-shrink-1 py-1" +
                        (!this.getAppContext().media.isMobile &&
                        !this.getAppContext().media.isTablet
                          ? " px-2"
                          : "")
                      }
                    >
                      <strong className="text-muted text-nowrap">
                        CONNECTION CRITERIA:
                      </strong>
                      <strong className="pl-2">
                        <span className="text-nowrap">
                          {this.state.data?.measures_list &&
                            this.state.data?.measures_list.length > 0 &&
                            this.state.data?.measures_list[0]
                              .connection_criteria}
                        </span>
                      </strong>
                    </div>
                    <div
                      className={
                        "flex-shrink-1 py-1" +
                        (!this.getAppContext().media.isMobile &&
                        !this.getAppContext().media.isTablet
                          ? " px-2"
                          : "")
                      }
                    >
                      <strong className="text-muted">TEST:</strong>
                      <strong className="pl-2">
                        <span className="text-nowrap">
                          {this.state.data?.measures_list &&
                            this.state.data?.measures_list.length > 0 &&
                            this.state.data?.measures_list[0].test}
                        </span>
                      </strong>
                    </div>
                    {this.state.data.measures_list &&
                      this.state.data.measures_list.length > 0 && (
                        <div
                          style={{ marginTop: "0.2em" }}
                          className={
                            "d-flex align-items-center " +
                            (!this.getAppContext().media.isMobile &&
                            !this.getAppContext().media.isTablet
                              ? " px-2"
                              : "")
                          }
                        >
                          <strong className="text-muted">TAGS:</strong>
                          {selectedTags
                            .sort((a, b) => {
                              const countDiff = b[1] - a[1];
                              return countDiff !== 0
                                ? countDiff
                                : a[0].localeCompare(b[0]);
                            })
                            .map((tag, id) => (
                              // <div className="mb-1">
                              <Badge
                                key={"tag__" + id}
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400",
                                }}
                                pill
                                className={`border ml-2 mb-1 bg-white border-gray700 text-gray700`}
                              >
                                <strong>{tag}</strong>
                              </Badge>
                              // </div>
                            ))}
                        </div>
                      )}
                  </Section>
                </small>
              </div>
            </div>
          </div>
        </Section>

        <Section className="mx-4 mb-3 mt-4" designType="wide">
          <div className="d-flex">
            <div className="flex-grow-1">
              <ReactOForm
                onControllerReady={(form_controller) => {
                  this._view_form = form_controller;
                }}
                onSubmit={(data, submit_cb, opt) => {
                  let viewRangeData;
                  if (data.is_preset == "yes") {
                    let startDate =
                      this.getAppContext().momentjs().unix() - data.view_preset;
                    viewRangeData = {
                      stime: startDate,
                      etime: this.getAppContext().momentjs().unix(),
                    };
                  } else {
                    viewRangeData = {
                      stime: parseInt(data.stime),
                      etime: parseInt(data.etime),
                    };
                  }
                  if (this.dateRangePicker.current) {
                    this.dateRangePicker.current.setStartDate(
                      this.getAppContext().momentjs(viewRangeData.stime, "X"),
                    );
                    this.dateRangePicker.current.setEndDate(
                      this.getAppContext().momentjs(viewRangeData.etime, "X"),
                    );
                  }
                  this.setState({ viewRangeData });
                  this.loadMeasuresList(data, submit_cb, opt);
                }}
              >
                <ReactOFormInput type="hidden" data_key="snapStime" />
                <ReactOFormInput type="hidden" data_key="snapEtime" />
                <ReactOFormInput
                  type="hidden"
                  data_key="stime"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").stime
                      : this.getAppContext().momentjs().unix()
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="etime"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").etime
                      : this.getAppContext().momentjs().unix()
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="offset"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").offset
                      : false
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="is_preset"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").is_preset
                      : "yes"
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="timeSnapshot"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").timeSnapshot
                      : false
                  }
                />

                <ReactOActionBar padding="0" alignV="start">
                  <div className="d-flex align-items-start flex-wrap">
                    <ReactOFormInput
                      type="select"
                      size={this.getAppContext().media.isMobile ? "sm" : ""}
                      data_key="view_preset"
                      color="primary"
                      nomarg
                      noSelectionLabel="Custom preset"
                      default={
                        this.getAppContext()
                          .getLocalStorageService()
                          .isSet("measure_graph_view")
                          ? this.getAppContext()
                              .getLocalStorageService()
                              .get("measure_graph_view").view_preset
                          : 3600 * 4
                      }
                      onOptionSelect={(form_ctrl, selected_value) => {
                        this.setState(
                          {
                            isCustom: false,
                            showInputTime: false,
                            invalidCustomRange: false,
                          },
                          () => {
                            form_ctrl.handleFormChange(
                              "view_preset",
                              selected_value,
                            );
                            form_ctrl.handleFormChange("is_preset", "yes");
                            form_ctrl.handleFormChange("offset", false);
                            form_ctrl.handleFormChange("snapStime", "");
                            form_ctrl.handleFormChange("snapEtime", "");
                            form_ctrl.submit();
                          },
                        );
                      }}
                      options={(form_data) => {
                        return [
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600
                                ? "1 hour"
                                : "Last hour",
                            value: 3600,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 4
                                ? "4 hours"
                                : "Last 4 hours",
                            value: 3600 * 4,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24
                                ? "24 hours"
                                : "Last 24 hours",
                            value: 3600 * 24,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24 * 7
                                ? "7 days"
                                : "Last 7 days",
                            value: 3600 * 24 * 7,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24 * 7 * 4
                                ? "4 weeks"
                                : "Last 4 weeks",
                            value: 3600 * 24 * 7 * 4,
                          },
                        ];
                      }}
                    />

                    <div className="ml-2">
                      {(() => {
                        let _offset =
                          this._view_form && this._view_form.isInitialized()
                            ? this._view_form.getEntry("offset")
                            : 0;
                        let _currentRange = this.state.viewRangeData
                          ? this.state.viewRangeData.etime -
                            this.state.viewRangeData.stime
                          : 0;
                        return (
                          <ButtonGroup>
                            <ReactOButton
                              icon="navigate-prev"
                              color={
                                _offset !== undefined && _offset < 0
                                  ? "success"
                                  : "secondary"
                              }
                              outline={_offset === undefined || _offset >= 0}
                              disabled={
                                (this.state.loading &&
                                  !this._IS_AUTO_RELOADING) ||
                                !_currentRange
                              }
                              onClick={() => {
                                let _offset =
                                  this._view_form.getEntry("offset") || 0;
                                let timeSnapshot = this.getAppContext()
                                  .momentjs()
                                  .unix();
                                let _new_offset =
                                  _offset !== undefined
                                    ? _offset - _currentRange / 2
                                    : -_currentRange / 2;
                                this._view_form.handleFormChange(
                                  "offset",
                                  _new_offset == 0 ? false : _new_offset,
                                );
                                this._view_form.handleFormChange(
                                  "timeSnapshot",
                                  timeSnapshot,
                                );

                                let stime, etime;
                                if (this._view_form.getEntry("snapStime")) {
                                  stime = this._view_form.getEntry("snapStime");
                                  etime = this._view_form.getEntry("snapEtime");
                                } else {
                                  stime = this.state.viewRangeData.stime;
                                  etime = this.state.viewRangeData.etime;
                                  this._view_form.handleFormChange(
                                    "snapStime",
                                    stime,
                                  );
                                  this._view_form.handleFormChange(
                                    "snapEtime",
                                    etime,
                                  );
                                }

                                const offsetStime = stime + _new_offset;
                                const offsetEtime = etime + _new_offset;

                                this._view_form.handleFormChange(
                                  "is_preset",
                                  "no",
                                );
                                this._view_form.handleFormChange(
                                  "stime",
                                  offsetStime,
                                );
                                this._view_form.handleFormChange(
                                  "etime",
                                  offsetEtime,
                                );
                                this._view_form.submit();
                              }}
                            />
                            <ReactOButton
                              icon="navigate-next"
                              color={
                                _offset !== undefined && _offset > 0
                                  ? "success"
                                  : "secondary"
                              }
                              outline={_offset === undefined || _offset <= 0}
                              disabled={
                                this.state.loading ||
                                !_currentRange ||
                                (this.state.viewRangeData?.etime &&
                                  this.checkFutureTime(
                                    this.state.viewRangeData.etime,
                                  ))
                              }
                              onClick={() => {
                                let _offset =
                                  this._view_form.getEntry("offset") || 0;
                                let timeSnapshot = this.getAppContext()
                                  .momentjs()
                                  .unix();
                                let _new_offset =
                                  _offset !== undefined
                                    ? _offset + _currentRange / 2
                                    : _currentRange / 2;
                                this._view_form.handleFormChange(
                                  "offset",
                                  _new_offset == 0
                                    ? false
                                    : Math.round(_new_offset),
                                );
                                this._view_form.handleFormChange(
                                  "timeSnapshot",
                                  timeSnapshot,
                                );

                                let stime, etime;
                                if (this._view_form.getEntry("snapStime")) {
                                  stime = this._view_form.getEntry("snapStime");
                                  etime = this._view_form.getEntry("snapEtime");
                                } else {
                                  stime = this.state.viewRangeData.stime;
                                  etime = this.state.viewRangeData.etime;
                                  this._view_form.handleFormChange(
                                    "snapStime",
                                    stime,
                                  );
                                  this._view_form.handleFormChange(
                                    "snapEtime",
                                    etime,
                                  );
                                }

                                const offsetStime = stime + _new_offset;
                                const offsetEtime = etime + _new_offset;

                                this._view_form.handleFormChange(
                                  "is_preset",
                                  "no",
                                );
                                this._view_form.handleFormChange(
                                  "stime",
                                  offsetStime,
                                );
                                this._view_form.handleFormChange(
                                  "etime",
                                  offsetEtime,
                                );
                                this._view_form.submit();
                              }}
                            />
                          </ButtonGroup>
                        );
                      })()}
                    </div>

                    <span className="ml-2">
                      <DateRangePicker
                        initialSettings={{
                          startDate:
                            this._view_form &&
                            this._view_form.isInitialized() &&
                            this._view_form.getEntry("is_preset") == "no"
                              ? this.getAppContext().momentjs(
                                  this._view_form.getEntry("stime"),
                                  "X",
                                )
                              : this.getAppContext().momentjs(),
                          endDate:
                            this._view_form &&
                            this._view_form.isInitialized() &&
                            this._view_form.getEntry("is_preset") == "no"
                              ? this.getAppContext().momentjs(
                                  this._view_form.getEntry("etime"),
                                  "X",
                                )
                              : this.getAppContext().momentjs(),
                          autoApply: true,
                          maxDate: this.getAppContext()
                            .momentjs()
                            .startOf("day")
                            .toDate(),
                        }}
                        ref={this.dateRangePicker}
                        onApply={(_e, picker) => {
                          let startDate = picker.startDate.unix();
                          let endDate = picker.endDate.unix() + 1;

                          this.setState(
                            {
                              showInputTime: false,
                              invalidCustomRange: false,
                            },
                            () => {
                              this._view_form.handleFormChange(
                                "is_preset",
                                "no",
                              );
                              this._view_form.handleFormChange(
                                "view_preset",
                                "no",
                              );
                              this._view_form.handleFormChange("offset", false);
                              this._view_form.handleFormChange(
                                "stime",
                                startDate,
                              );
                              this._view_form.handleFormChange(
                                "etime",
                                endDate,
                              );
                              this._view_form.submit();
                            },
                          );
                        }}
                      >
                        <button
                          id="_ag_drp"
                          disabled={
                            this.state.loading && !this._IS_AUTO_RELOADING
                          }
                          className="selected-date-range-btn text-nowrap nofocus btn btn-outline-secondary mr-2"
                        >
                          <span className="icon-calendar" />
                        </button>
                      </DateRangePicker>
                    </span>
                    <ReactOTooltip
                      placement="top"
                      delay={{ show: 200 }}
                      target="_ag_drp"
                      text="Select a custom date range"
                    />

                    <button
                      disabled={this.state.loading && !this._IS_AUTO_RELOADING}
                      style={
                        this.state.showInputTime ? { display: "none" } : {}
                      }
                      className="selected-date-range-btn text-nowrap nofocus btn btn-outline-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState(
                          {
                            showInputTime: true,
                          },
                          () => {
                            this.setState({ range: this.parseTime() });
                          },
                        );
                      }}
                    >
                      <span style={{ marginRight: "8px" }} />
                      {this.parseTime()}
                    </button>

                    {this.state.showInputTime == true ? (
                      <span>
                        <Input
                          className="width-input form-control custom-input-header-modal"
                          bsSize="xs"
                          value={this.handleCustomRange()}
                          autoFocus
                          type="text"
                          invalid={this.state.invalidCustomRange}
                          disabled={this.state.loading}
                          onKeyDown={(e) => {
                            if (
                              e.key == "Enter" &&
                              !this.state.invalidCustomRange
                            ) {
                              e.preventDefault();
                              this.submitCustomRange();
                            } else if (
                              e.key == "Enter" &&
                              this.state.invalidCustomRange
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (this._AUTO_RELOAD_TIMEOUT) {
                              clearTimeout(this._AUTO_RELOAD_TIMEOUT);
                            }
                            e.preventDefault();
                            let string = e.target.value;
                            this.setState({
                              invalidCustomRange: false,
                              isCustom: true,
                              range: string,
                            });
                          }}
                        />
                        <FormFeedback>
                          {this.state.invalidCustomRangeMsg}
                        </FormFeedback>
                        {!this.state.invalidCustomRangeMsg && (
                          <FormText
                            color="muted"
                            className="d-flex align-items-start"
                          >
                            <span
                              className="icon-info mr-1"
                              style={{ fontSize: "120%" }}
                            />
                            Press "Enter" to submit
                          </FormText>
                        )}
                      </span>
                    ) : (
                      <span />
                    )}

                    {this._view_form &&
                    this._view_form.isInitialized() &&
                    this._view_form.getEntry("offset") !== undefined ? (
                      <ButtonGroup className="ml-2">
                        <ReactOButton
                          icon="close-outline"
                          disabled={
                            this.state.loading && !this._IS_AUTO_RELOADING
                          }
                          onClick={() => {
                            this._view_form.handleFormChange("offset", false);
                            const snapStime = parseInt(
                              this._view_form.getEntry("snapStime"),
                            );
                            const snapEtime = parseInt(
                              this._view_form.getEntry("snapEtime"),
                            );
                            this._view_form.handleFormChange(
                              "stime",
                              snapStime - (snapStime % 60),
                            );
                            this._view_form.handleFormChange(
                              "etime",
                              snapEtime - (snapEtime % 60),
                            );
                            this._view_form.submit();
                          }}
                        />
                      </ButtonGroup>
                    ) : null}
                  </div>
                </ReactOActionBar>
              </ReactOForm>
            </div>
            <div className="align-self-end text-right">
              {this.getAppContext().isCloud() ? (
                <div>
                  <small className="text-muted">
                    {this.state.conf_set &&
                    this.state.conf_set.probe_status == "not_deployed" &&
                    this.state.conf_set.sync_status == 1 ? (
                      <span>Probe not deployed</span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "maintenance" &&
                      this.state.conf_set.sync_status == 1 ? (
                      <span>Probe in maintenance</span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "deployed" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <span>
                        Probe <span className="text-danger">Offline</span>
                      </span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "not_deployed" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <span>
                        Probe not deployed{" "}
                        <span className="text-danger">Offline</span>
                      </span>
                    ) : this.state.conf_set &&
                      this.state.conf_set.probe_status == "maintenance" &&
                      this.state.conf_set.sync_status == 0 ? (
                      <span>
                        Probe in maintenance{" "}
                        <span className="text-danger">Offline</span>
                      </span>
                    ) : (
                      <div className="mb-4" />
                    )}
                  </small>
                </div>
              ) : null}
              <small className="text-muted">
                Most recent measure at:{" "}
                <strong>
                  {this.state.data.last_update
                    ? this.getAppContext()
                        .momentjs(this.state.data.last_update, "X")
                        .format("L LT")
                    : "-"}
                </strong>
              </small>
            </div>
          </div>
        </Section>

        <_LoadingWrapper
          minHeight
          loadingPlug={this.state.loading && !this._IS_AUTO_RELOADING}
        >
          {this.state.connectionCriteria && (
            <MeasureAggregateList
              viewrange={this.state.viewrange}
              data={this.state.filteredData ? this.state.filteredData : null}
              freqData={this.state.freqData ? this.state.freqData : null}
              cssids={this.props.location?.state?.cssids || []}
              selectedTags={this.props.location?.state?.selectedTags || []}
              mlist={this.props.location.state.mlist || {}}
              connectionCriteria={this.state.connectionCriteria}
            />
          )}
        </_LoadingWrapper>

        <div className="mx-4 text-center">
          {false && `You have <n> archived measures`}
        </div>
      </Section>
    );
  }
}

export default contextProvider(AggregateMeasuresFlat, {
  define: null,
});
